// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Maximize2 } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconMaximize2(props: any) {
    return <IconBase icon={Maximize2} {...props} />
  }

  export default IconMaximize2
  